import { z } from 'zod';
import { adminApiFetch } from './apiService';
import { apiSuccess, apiList } from '@services/apiSchemas';

// 對應 app/controllers/api/admin/v1/inventory_attribute_definitions_controller.rb
//   index/create/update 都吐 model 預設 as_json
export const InventoryAttributeDefinitionSchema = z.object({
  id: z.string(),
  organization_id: z.string(),
  merchant_id: z.string(),
  name: z.string(),
  label: z.string(),
  data_type: z.string(),
  options: z.unknown(),
  required: z.boolean(),
  position: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
}).passthrough();

export type InventoryAttributeDefinition = z.infer<typeof InventoryAttributeDefinitionSchema>;

export const inventoryAttributeDefinitionService = {
  // 獲取所有定義
  fetchList: async (params: Record<string, unknown> = {}) => {
    const queryParams = new URLSearchParams(params as Record<string, string>).toString();
    const url = queryParams ? `inventory_attribute_definitions?${queryParams}` : 'inventory_attribute_definitions';
    const response = await adminApiFetch(url, { method: 'GET' });
    return apiList(InventoryAttributeDefinitionSchema).parse(await response.json());
  },

  // 獲取單個定義
  get: async (id: string) => {
    const response = await adminApiFetch(`inventory_attribute_definitions/${id}`, {
      method: 'GET'
    });
    return apiSuccess(InventoryAttributeDefinitionSchema).parse(await response.json());
  },

  // 創建定義
  create: async (data: Record<string, unknown>) => {
    const response = await adminApiFetch('inventory_attribute_definitions', {
      method: 'POST',
      body: { inventory_attribute_definition: data }
    });
    return apiSuccess(InventoryAttributeDefinitionSchema).parse(await response.json());
  },

  // 更新定義
  update: async (id: string, data: Record<string, unknown>) => {
    const response = await adminApiFetch(`inventory_attribute_definitions/${id}`, {
      method: 'PUT',
      body: { inventory_attribute_definition: data }
    });
    return apiSuccess(InventoryAttributeDefinitionSchema).parse(await response.json());
  },

  // 刪除定義
  delete: async (id: string) => {
    const response = await adminApiFetch(`inventory_attribute_definitions/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};

export default inventoryAttributeDefinitionService;
